import * as types from "../actionTypes";

export const setOtherAdvertisementAndMarketingExpenseByYear = (
  key,
  yearKey,
  amount
) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setOtherAdvertisementAndMarketingExpenseByMonth = (
  key,
  yearKey,
  amount
) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceOtherAdvertisementAndMarketingExpenseYears = (
  key,
  payload
) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_YEARS,
      key,
      payload,
    });
  };
};

export const resetOtherAdvertisementAndMarketingExpenseReducer = (
  key,
  payload
) => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_OTHER_ADVERTISEMENT_AND_MARKETING_EXPENSE_REDUCER,
      key,
      payload,
    });
  };
};
